import React from 'react';
import { colors } from '../../../colors';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';

interface Props {
  isOrganization: boolean | undefined;
}

export default function DebtorIcon(props: Props) {
  const icons = {};
  icons['organization'] = { tooltip: 'Organisasjon', offset: '-3px', backgroundColor: colors.primary, path: BusinessIcon };
  icons['person'] = { tooltip: 'Person', offset: '-4px', backgroundColor: colors.primary, path: PersonIcon };
  const icon = icons[(props.isOrganization === true) ? 'organization' : 'person'];

  return (
    <>
      {<icon.path alt={icon.tooltip} title={icon.tooltip} style={{
        backgroundColor: icon.backgroundColor,
        marginBottom: icon.offset,
        marginRight: '5px'
      }} />}
    </>
  );
};
